import React from 'react';

import StyledIndividualityItemValue from './styled';

interface PropsType {
	label: string;
	type: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
}

function IndividualityItemValue({ label, type }: PropsType) {
	return <StyledIndividualityItemValue color={type} label={label} />;
}

export default IndividualityItemValue;
